import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { H2 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'

const MarketingContent = ({ content, ...props }) =>
  <Wrapper { ...props }>
    <Header>
      <Title bold size={ 16 } inline>FROM THE MANUFACTURER</Title>
    </Header>
    <div dangerouslySetInnerHTML={{ __html: content }} />
  </Wrapper>

export default MarketingContent

MarketingContent.propTypes = {
  content: PropTypes.string
}

const Wrapper = styled.div`
  margin-bottom: 100px;
  ${Mixin.responsive('margin-top', '-70px', '-50px')}
  ${Media.desktop`
    padding: ${props => props.padding_desktop || '0'};
    margin:  ${props => props.margin_desktop || '0'};
  `}
  ${Media.mobile`
    padding: ${props => props.padding_mobile || '0'};
    margin:  ${props => props.margin_mobile || '0'};
  `}
`

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Title = styled(H2)`
  ${Mixin.responsive('margin', '0 0 25px', '0 0 16px')}
  ${Mixin.responsive('font-size', '26px', '20px')}
`

MarketingContent.propType = {
  content: PropTypes.string
}
